// src/components/UserProfile.js
import React, { useEffect, useState } from 'react';
// import { useGoogleLogin } from '@react-oauth/google';
import { postUserInfo } from '../utils/api';
import config from '../config/config.json';
import Login from './pages/Login';

export const logout = async () => {
  const accessToken = localStorage.getItem('access_token');
  localStorage.removeItem('access_token');
  localStorage.removeItem('user');
  window.location.href = config.appBaseUrl;
  await fetch('https://accounts.google.com/o/oauth2/revoke?token=' + accessToken, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

const UserProfile = ({ onLogin }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setLoading(true);
      setUser(storedUser);
      postUserInfo(storedUser).then(() => setLoading(false));
    }
  }, []);

  if (!user) {
    return <Login onLogin={onLogin} />;
    // return <button onClick={() => login()}>Login with Google</button>;
  }

  return null;
};

export default UserProfile;